import { CardHeader, DragAndDropCard, ProgressBar } from "@adeccoux/tag-ds";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    CommonLoader,
    CommonPopup,
    CommonQuesProgress,
    QuesLoader,
    SessionExpireCommonPopup,
    useScreenTransition,
    useTimer,
    redirectToAssessmentSummary,
    useTimerValues,
    QuestionCommonPopup,
} from "../../util/common";
import { TEST_COMPLETE, TEST_QUESTIONS } from "../../util/constants";
import { getNoCacheCall, postCall, getTimerValue } from "../../util/resources";
import SesHeader from "../header";
import DragDrop from "../DragDrop/dragDrop";
import { BaseContext } from "../../App";
import WarmupComplete from "../instructions/warmupComplete";

const TestTaker24 = () => {
    const [isDragandDrop, setIsDragandDrop] = useState(false);
    const [isSingleChoice, setIsSingleChoice] = useState(false);
    const [isMultiChoice, setIsMultiChoice] = useState(false);
    const [orderData, setOrderData] = useState([]);
    const [defaultOrderData, setDefaultOrderData] = useState([]);
    const [test, setTest] = useState();
    const [questionData, setQuestionData] = useState({});
    const [originalAns, setOriginalAns] = useState([]);
    const [selectedAns, setSelectedAns] = useState(-1);
    const [startMainTest, setStartMainTest] = useState(false);
    const [timeLimit, setTimeLimit] = useState(0);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });

    const [qpopupData, setQpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });

    const [sessionStatus, setSessionStatus] = useState(false);
    const { min, sec, totalSecLeft, startTimer, stopTimer, getElapsedTime } =
        useTimer();
    const { phase, loading, startTransition, done } = useScreenTransition();
    const { isWarmupDoneShown, setWarmupDoneShown } = useContext(BaseContext);
    const location = useLocation();
    const { timerOverallAssessment } = useTimerValues();
    const { timerPerQuestion } = useTimerValues();
    const { timerPerTopic } = useTimerValues();
    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const formRef = useRef();
    const quesNo = useRef(-1);
    const answerData = useRef(-1);
    const attachKeyListenRef = useRef();
    const keyMappings = useRef({});
    const currentIndex = useRef(0);
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });

    const stepRef = useRef();
    const isWarmUp = location.state.warmUp;
    const assessmentTimerStarted = useRef({
        type: "",
        started: false,
        limit: -1,
    });
    const previewDataLocal = useRef(location.state.previewData);
    const firstPrev = useRef(0);
    const timeEnded = useRef(false);
    const totalElapsedTime = useRef(0);
    const qattempts = useRef(0);

    useEffect(() => {
        if (totalSecLeft === 0) {
            if (
                assessmentTimerStarted.current?.type === "assessment" ||
                (assessmentTimerStarted.current?.type === "timedByTopic" &&
                    assessmentTimerStarted.current?.nextPageId === 0) ||
                (assessmentTimerStarted.current?.type === "timeByQuestion" &&
                    test.lastPage)
            ) {
                setSessionStatus(true);
            } else {
                timeEnded.current = true;
                nextNavigate("timeEnded");
            }
        }
        if (
            test &&
            (assessmentTimerStarted.current?.type === "assessment" ||
                assessmentTimerStarted.current?.type === "timedByTopic")
        ) {
            stepRef.current?.children?.[1]?.children?.[0]?.setAttribute(
                "data-secLeft",
                `${min}:${sec}`
            );
        }
    }, [totalSecLeft]);

    useEffect(() => {
        getQuestion();
    }, [isWarmUp, startMainTest]);

    useEffect(() => {
        attachKeyListenRef.current?.focus({
            preventScroll: true,
        });
    }, [test]);

    const getQuestion = async () => {
        try {
            var response;
            if (assessmentTimerStarted.current?.type === "timeByQuestion") {
                timeEnded.current = false;
            }
            if (isWarmUp) {
                response =
                    location.state.test.testExample[currentIndex.current];
            } else if (previewDataLocal.current) {
                if (quesNo.current === -1) {
                    quesNo.current = 1;
                }
                response = previewDataLocal.current[quesNo.current - 1];
            } else {
                const apiResponse = await getNoCacheCall(
                    TEST_QUESTIONS +
                    location.state.test.id +
                    "/" +
                    quesNo.current,
                    header.current
                );
                response = apiResponse.data[0];
            }
            if (!isWarmUp) {
                let dcTime = atob(response.questions[0].encTmLmt);
                let dcTimeFi = dcTime.split(":");
                if (
                    location.state.test.timeByQuestion &&
                    location.state.test.bShowTimer
                ) {
                    startTimer(parseInt(dcTimeFi[1], 10), "timeByQuestion");
                    assessmentTimerStarted.current.type = "timeByQuestion";
                } else if (
                    location.state.test.bShowTimer &&
                    location.state.test.timeLimit &&
                    !assessmentTimerStarted.current?.started
                ) {
                    const timeLimit = atob(location.state.test.encTmLmt).split(
                        ":"
                    )[1];
                    assessmentTimerStarted.current = {
                        type: "assessment",
                        started: true,
                        limit: timeLimit,
                    };
                    setTimeLimit(timeLimit);
                    startTimer(timeLimit - location.state.test.duration);
                } else if (
                    location.state.test.bShowTimer &&
                    location.state.test.timedByTopic
                ) {
                    const timeLimit = atob(
                        response.questions[0].encTpcTmLmt
                    ).split(":")[1];
                    setTimeLimit(timeLimit);
                    startTimer(
                        timeLimit -
                        (assessmentTimerStarted.current
                            ?.perTopicDurations?.[
                            response.questions[0].topicName
                        ]
                            ? assessmentTimerStarted.current
                                ?.perTopicDurations?.[
                            response.questions[0].topicName
                            ]
                            : 0),
                        "timedByTopic"
                    );
                    assessmentTimerStarted.current = {
                        ...assessmentTimerStarted.current,
                        type: "timedByTopic",
                        started: true,
                        limit: timeLimit,
                        topicName: response.questions[0].topicName,
                        nextPageId: response.questions[0].nextPageId,
                    };
                } else {
                    startTimer();
                }
            }
            setTest(response);
            setSelectedAns(
                response.questions[0].userAnswer
                    ? response.questions[0].userAnswer.value
                    : -1
            );
            const deepClone = structuredClone(response.questions[0].answers);
            setOriginalAns(deepClone);

            quesNo.current = response.startNumber;
            let key;
            keyMappings.current = {};
            response.questions[0].answers?.map((val) => {
                key = `Digit${val.position + 1}`;
                keyMappings.current = {
                    ...keyMappings.current,
                    [key]: val.position,
                };
            });
            setIsDragandDrop(response.questions[0].allowRanking);
            setIsSingleChoice(
                response.questions[0].allowRanking === false &&
                    response.questions[0].answers[0].groupId.toString() === "2"
                    ? false
                    : true
            );
            setIsMultiChoice(
                response.questions[0].allowRanking === false &&
                    response.questions[0].answers[0].groupId.toString() === "2"
                    ? true
                    : false
            );
            if (response.questions[0].allowRanking) {
                await handleOrderData(response);
            }
            if (response.questions[0].answers[0].groupId.toString() === "2") {
                await handleMultiChoiceData(response.questions[0]).then(
                    (finalData) => {
                        setQuestionData({ answers: finalData });
                    }
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleMultiChoiceData = async (data) => {
        const newData = Object.assign({}, data);
        let userAnswer = "";
        if (newData.userAnswer) {
            if (
                newData.userAnswer.value &&
                newData.userAnswer.value.toString() !== "-1"
            ) {
                userAnswer = newData.userAnswer.value.split("#$#");
                let userChoice = parseInt(userAnswer[0], 10);
                for (let i = 0; i < newData.answers.length; i++) {
                    if (userChoice & Math.pow(2, i) && userChoice !== -1) {
                        newData.answers[i].selected = true;
                    } else {
                        newData.answers[i].selected = false;
                    }
                }
                return newData.answers;
            } else {
                return data.answers;
            }
        } else {
            return data.answers;
        }
    };

    const handleOrderData = async (data) => {
        if (data.questions[0].userAnswer !== null) {
            const userAnswer = data.questions[0].userAnswer.value.split("#$#");
            const userChoice = userAnswer[0];
            if (data.questions[0].allowRanking) {
                let savedPos = userChoice.split(",");
                let defaultAns = [];
                let savedAnsArr = [];
                let quesAns = structuredClone(data.questions[0].answers);
                quesAns.map((val) => {
                    if (savedPos.some((sp) => sp == val.position.toString())) {
                        savedAnsArr.push(val);
                    } else {
                        defaultAns.push(val);
                    }
                });
                setDefaultOrderData(defaultAns);
                setOrderData(savedAnsArr);
            }
        } else if (data.questions[0].allowRanking) {
            setDefaultOrderData(structuredClone(data.questions[0].answers));
        }
    };

    const buildMediaUrl = (file) => {
        let builtUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/static";
        builtUrl += (file.startsWith("/") ? "" : "/") + file;
        return builtUrl;
    };

    const changeSelectedAns = (e) => {
        answerData.current = e.target.value;
        setSelectedAns(e.target.value);
    };

    const changeMultiSelectedAns = (multiData, index) => {
        var tempData = { ...multiData };
        if (tempData.selected) {
            tempData.selected = false;
        } else {
            tempData.selected = true;
        }
        setQuestionData({
            ...questionData,
            ...(questionData.answers[index] = tempData),
        });
    };

    const detectKeyDown = (e) => {
        e.preventDefault();
        if (!loading) {
            if (e.code in keyMappings.current) {
                if (test.questions[0].answers?.[0]?.groupId === "1") {
                    setSelectedAns(keyMappings.current[e.code]);
                    answerData.current = keyMappings.current[e.code];
                } else if (test.questions[0].answers?.[0]?.groupId === "2") {
                    setQuestionData({
                        ...questionData,
                        ...(questionData.answers[
                            keyMappings.current[e.code]
                        ].selected =
                            !questionData.answers[keyMappings.current[e.code]]
                                .selected),
                    });
                }
            }
            if (!setNextDisable() && e.code === "Space") {
                if(qpopupData?.isOpen){
                    qPopUpAction();
                }else{
                    nextNavigate();
                }
            }
        }
    };

    const previousNavigate = () => {
        if (
            (assessmentTimerStarted.current?.type === "timeByQuestion" &&
                timeEnded.current) ||
            (assessmentTimerStarted.current?.type === "timedByTopic" &&
                quesNo.current - 1 < timeEnded.current)
        ) {
            return;
        }
        setSelectedAns(-1);
        setQuestionData({});
        setOrderData([]);
        formRef.current.reset();
        quesNo.current -= 2;
        nextNavigate(true);
    };

    const [rightAns, setrightAns] = useState(false);

    const validateAnsw = (selAns, question) => {
        const feedbackEnabled = !!question?.questions?.[0]?.feedback;
        if (!rightAns) {
            let correctAns = false;
            let currectAnsVal = [];

            for (let i = 0; i < question.questions[0].answers.length; i++) {
                if (question.questions[0].answers[i].score == 1) {
                    currectAnsVal.push(question.questions[0].answers[i]);
                    if (isMultiChoice) {
                        const correct = question.questions[0].answers.filter(
                            (a) => a.score == 1
                        );
                        const selected = question.questions[0].answers.filter(
                            (a) => a.selected
                        );
                        correctAns =
                            correct.length == selected.length &&
                            selected.every((a) => a.score == 1);
                    } else {
                        if (
                            question.questions[0].answers[i].position == selAns
                        ) {
                            correctAns = true;
                        } else {
                            correctAns = false;
                        }
                    }
                }
            }
            if(feedbackEnabled){
                let message;

                if (correctAns) {
                    setrightAns(true);
                    message = phrases?.["15145"];
                } else {
                    switch (qattempts.current) {
                        case 0:
                            message = phrases?.["15146"];
                            qattempts.current = qattempts.current + 1;
                            break;
                        case 1:
                            message = phrases?.["15147"];
                            qattempts.current = qattempts.current + 1;
                            break;

                        default:
                            message =
                                phrases?.["15148"] +
                                "<br>" +
                                currectAnsVal.map((val, index) => val.content) +
                                phrases?.["15149"];
                            message = String(message);
                            qattempts.current = qattempts.current + 1;
                            break;
                    }
                }
                message = message.split("\\n").join("<br />");
                message =
                    `<span style="font-size: medium;vertical-align: text-top;padding-right: 5px;" class="material-icons ${correctAns ? "icon-success" : "icon-error"
                    }">${correctAns ? "check_circle" : "info"}</span>` + message;
                setQpopupData((prev) => {
                    prev = {
                        ...prev,
                        isOpen: question?.questions[0]?.feedback, //feedback value added
                        popupHeader: phrases?.["10980"],
                        popupBody: message,
                        popupFooter: phrases?.["10928"],
                    };
                    return prev;
                });
            }
        } else {
            setrightAns(false);
            if (test.lastPage) {
                stopTimer();
                if(location.state.previewData){
                    navigate("/instructions", {
                        state: {...location.state},
                    });
                }else{
                    setWarmupDoneShown(true);
                }
            } else {
                qattempts.current = 0;
                getQuestion();
            }
        }
        return { feedbackEnabled };
    };

    const nextNavigate = async (previous = false) => {
        startTransition(
            async () => {
                if (previous === true) {
                    firstPrev.current += 1;
                } else {
                    firstPrev.current = 0;
                }
                if (isWarmUp) {
                    const { feedbackEnabled } = await validateAnsw(
                        selectedAns,
                        location.state.test.testExample[currentIndex.current]
                    );
                    if (
                        location.state.test.testExample.length - 1 >
                        currentIndex.current &&
                        rightAns
                    ) {
                        currentIndex.current = currentIndex.current + 1;
                        await getQuestion();
                    }
                    if(!feedbackEnabled && selectedAns >= 0){
                        if (test.lastPage) {
                            stopTimer();
                            if(location.state.previewData){
                                navigate("/instructions", {
			                        state: {...location.state},
			                    });
                            }else{
                                setWarmupDoneShown(true);
                            }
                        }else{
                            currentIndex.current = currentIndex.current + 1;
                            await getQuestion();
                        }
                    }
                } else {
                    const elapsedTime = stopTimer();
                    let finalAnsData;
                    let finalVal = null;
                    if (isMultiChoice) {
                        let multiChoiceAns = test.questions[0].answers;
                        for (let i = 0; i < multiChoiceAns.length; i++) {
                            let currentAns = multiChoiceAns[i];
                            if (currentAns.selected) {
                                finalVal += Math.pow(2, i);
                            }
                        }
                        finalAnsData = finalVal;
                    } else if (isDragandDrop) {
                        let positionVal = "";
                        orderData.map((data) => {
                            positionVal += positionVal.length > 0 ? "," : "";
                            positionVal += data.position;
                        });

                        finalAnsData = positionVal;
                    } else if (isSingleChoice) {
                        if (selectedAns !== -1) {
                            finalAnsData = answerData?.current;
                        }
                    }

                    const ansObj = {
                        answers: [],
                        structure: null,
                        value: finalAnsData?.toString(),
                    };
                    let quesObj = test.questions;
                    quesObj[0].userAnswer = ansObj;
                    quesObj[0].answers = originalAns;
                    if (
                        assessmentTimerStarted.current?.type === "timedByTopic"
                    ) {
                        totalElapsedTime.current += elapsedTime;
                    }
                    if (
                        assessmentTimerStarted.current?.type ===
                        "timeByQuestion"
                    ) {
                        quesObj[0].duration = elapsedTime;
                    }
                    const otherData = {
                        duration:
                            assessmentTimerStarted.current?.type ===
                                "timeByQuestion"
                                ? elapsedTime
                                : assessmentTimerStarted.current?.type ===
                                    "timedByTopic"
                                    ? location.state.test.duration +
                                    totalElapsedTime.current
                                    : location.state.test.duration + elapsedTime,
                        fwdtimes: "",
                        instrumentType: "",
                        pause: firstPrev.current === 1,
                        playTimes: "",
                        rwdTimes: "",
                    };
                    if (
                        assessmentTimerStarted.current?.type === "timedByTopic"
                    ) {
                        assessmentTimerStarted.current.perTopicDurations = {
                            ...assessmentTimerStarted.current.perTopicDurations,
                            [test.questions[0].topicName]:
                                (assessmentTimerStarted.current
                                    ?.perTopicDurations?.[
                                    test.questions[0].topicName
                                ] || 0) + getElapsedTime(),
                        };
                        if (
                            timeLimit <=
                            assessmentTimerStarted.current?.perTopicDurations?.[
                            test.questions[0].topicName
                            ]
                        ) {
                            timeEnded.current = test.questions[0].nextPageId;
                        }
                    }

                    try {
                        let response;
                        let setTimedbytopicFlag = false;
                        if (
                            (test.lastPage && previous !== true) ||
                            previous === "timeEnded"
                        ) {
                            if (previewDataLocal.current) {
                                previewDataLocal.current[
                                    quesNo.current - 1
                                ].questions = quesObj;
                            } else {
                                if (
                                    assessmentTimerStarted.current?.type ===
                                    "assessment" ||
                                    (assessmentTimerStarted.current?.type ===
                                        "timedByTopic" &&
                                        assessmentTimerStarted.current
                                            ?.nextPageId === 0) ||
                                    (assessmentTimerStarted.current?.type ===
                                        "timeByQuestion" &&
                                        test.lastPage) ||
                                    assessmentTimerStarted.current?.type == ""
                                ) {
                                    response = await postCall(
                                        TEST_COMPLETE + location.state.test.id,
                                        { ...otherData, questions: quesObj },
                                        header.current
                                    );
                                    redirectToAssessmentSummary(
                                        location,
                                        navigate
                                    );
                                } else {
                                    setTimedbytopicFlag = true;
                                    response = await postCall(
                                        TEST_QUESTIONS + location.state.test.id,
                                        { ...otherData, questions: quesObj },
                                        header.current
                                    );
                                }
                            }
                        } else {
                            if (previewDataLocal.current) {
                                previewDataLocal.current[
                                    quesNo.current - 1
                                ].questions = quesObj;
                            } else {
                                response = await postCall(
                                    TEST_QUESTIONS + location.state.test.id,
                                    { ...otherData, questions: quesObj },
                                    header.current
                                );
                            }
                        }
                        if (
                            response?.data?.status === true ||
                            previewDataLocal.current
                        ) {
                            if (test.lastPage && previous !== true) {
                                navigate("/");
                            } else {
                                setSelectedAns(-1);
                                setQuestionData({});
                                setOrderData([]);
                                formRef.current.reset();
                                if (
                                    assessmentTimerStarted.current?.type ===
                                    "timedByTopic" &&
                                    setTimedbytopicFlag === true
                                ) {
                                    quesNo.current =
                                        assessmentTimerStarted.current?.nextPageId;
                                } else {
                                    quesNo.current += 1;
                                }
                                await getQuestion();
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
                done();
            },
            isWarmUp || previewDataLocal.current ? false : true
        );
    };

    const handleExampleStart = () => {
        setWarmupDoneShown(true);
    };

    const exitTest = () => {
        if (previewDataLocal.current) {
            window.close();
        } else
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: location.state.test.name,
                    popupBody: phrases?.["1002189"],
                    popupFooter: phrases?.["14392"],
                };
                return prev;
            });
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
        stopTimer();
        navigate("/");
    };

    const approveAction = async () => {
        let finalAnsData;
        let finalVal = null;
        if (isMultiChoice) {
            let multiChoiceAns = test.questions[0].answers;
            for (let i = 0; i < multiChoiceAns.length; i++) {
                let currentAns = multiChoiceAns[i];
                if (currentAns.selected) {
                    finalVal += Math.pow(2, i);
                }
            }
            finalAnsData = finalVal;
        } else if (isDragandDrop) {
            let positionVal = "";
            orderData.map((data) => {
                positionVal += positionVal.length > 0 ? "," : "";
                positionVal += data.position;
            });

            finalAnsData = positionVal;
        } else if (isSingleChoice) {
            if (selectedAns !== -1) {
                finalAnsData = answerData?.current;
            }
        }
        const ansObj = { answers: [], structure: null, value: finalAnsData };
        const elapsedTime = stopTimer();
        let quesObj = test.questions;
        quesObj[0].userAnswer = ansObj;
        if (assessmentTimerStarted.current?.type === "timedByTopic") {
            totalElapsedTime.current += elapsedTime;
        }
        if (assessmentTimerStarted.current?.type === "timeByQuestion") {
            quesObj[0].duration = elapsedTime;
        }
        const otherData = {
            duration:
                assessmentTimerStarted.current?.type === "timeByQuestion"
                    ? elapsedTime
                    : assessmentTimerStarted.current?.type === "timedByTopic"
                        ? location.state.test.duration + totalElapsedTime.current
                        : location.state.test.duration + elapsedTime,
        };
        await postCall(
            TEST_COMPLETE + location.state.test.id,
            { ...otherData, questions: quesObj },
            header.current
        );
        redirectToAssessmentSummary(location, navigate);
    };

    const setNextDisable = () => {
        if (isDragandDrop) {
            let isNext = true;
            for (let index = 0; index < orderData?.length; index++) {
                if (orderData?.[index]?.content) {
                    isNext = false;
                }
            }
            return isNext;
        } else if (isMultiChoice) {
            let isNext = true;
            for (
                let index = 0;
                index < questionData?.answers?.length;
                index++
            ) {
                if (questionData?.answers?.[index]?.selected === true) {
                    isNext = false;
                }
            }
            return isNext;
        } else if (isSingleChoice) {
            return selectedAns === -1;
        } else {
            return true;
        }
    };

    const sessionApproveAction = async () => {
        setSessionStatus(false);
        if (previewDataLocal.current) {
            window.close();
        }
        nextNavigate("timeEnded");
    };

    const openAttachment = function (attachment) {
        window.open("../static/qdoc/" + attachment.url, "_blank");
    };

    const attachmentTypeIcon = function (attachment) {
        var fileClass;
        switch (attachment.type.toLowerCase()) {
            case "doc":
            case "docx":
                fileClass = "description";
                break;
            case "pdf":
                fileClass = "picture_as_pdf";
                break;
            case "ppt":
            case "pptx":
                fileClass = "slideshow";
                break;
            case "bmp":
            case "tif":
            case "tiff":
                fileClass = "image";
                break;
            case "mpg":
            case "mpeg":
                fileClass = "video_file";
                break;
            case "wav":
                fileClass = "audiotrack";
                break;
            case "msg":
                fileClass = "local_post_office";
                break;
            default:
                fileClass = "archive";
        }
        return fileClass;
    };

    const backtoInst = () => {
        navigate("/instructions", {
            state: { ...location.state },
        });
    };

    const handleMainTestStart = () => {
        currentIndex.current = 0;
        quesNo.current = -1;
        setStartMainTest(true);
        navigate("/TT24", {
            state: { ...location.state, warmUp: false },
        });
    };
    const qPopUpAction = () => {
        setQpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    if (!test) {
        return <CommonLoader />;
    }

    if (isWarmupDoneShown) {
        return (
            <WarmupComplete
                backtoInst={backtoInst}
                handleMainTestStart={handleMainTestStart}
            />
        );
    }

    return (
        <div
            className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width"
            ref={attachKeyListenRef}
            tabIndex="-1"
            onKeyDown={detectKeyDown}
            onBlur={(e) =>
                e.target.focus({
                    preventScroll: true,
                })
            }
            style={{ outline: "none" }}
        >
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
            <QuestionCommonPopup
                popupData={qpopupData}
                closeAction={qPopUpAction}
                approveAction={qPopUpAction}
            />
            <SessionExpireCommonPopup
                sessionStatus={sessionStatus}
                sessionApproveAction={sessionApproveAction}
            />
            <SesHeader
                clientCobranding={location.state.cobrandingLink}
                isWarmUp={isWarmUp}
            />
            <div
                ref={stepRef}
                className="top-progress-container flex_row sticky full-width g3 bg01"
            >
                <CommonQuesProgress test={test} />
                {assessmentTimerStarted.current?.type === "assessment" ||
                    assessmentTimerStarted.current?.type === "timedByTopic" ? (
                    <ProgressBar
                        circular
                        step={totalSecLeft}
                        steps={timeLimit}
                        circularColorClass={
                            (timerOverallAssessment !== undefined &&
                                assessmentTimerStarted.current?.type ===
                                "assessment" &&
                                totalSecLeft <= timerOverallAssessment) ||
                                (assessmentTimerStarted.current?.type ===
                                    "timedByTopic" &&
                                    timerPerTopic !== undefined &&
                                    totalSecLeft <= timerPerTopic)
                                ? "progress-bar-color"
                                : ""
                        }
                    />
                ) : (
                    <></>
                )}
            </div>
            <div className="flex_col g2">
                <h3>
                    {isWarmUp
                        ? location.state.test.testExampleName
                        : location.state.test.name}
                </h3>
                {test.questions[0].attachments &&
                    test.questions[0].attachments.map((val, ind) => (
                        <button
                            className="button-secondary text_uppercase mr1"
                            style={{ width: "fit-content" }}
                            key={ind}
                            onClick={() => openAttachment(val)}
                            disabled={loading}
                        >
                            <span className="material-icons-outlined left mr1">
                                {attachmentTypeIcon(val)}
                            </span>{" "}
                            {phrases?.["1001963"]}
                        </button>
                    ))}
            </div>
            <form
                ref={formRef}
                className={
                    location.state.test.displayType === "3"
                        ? "flex_col position_relative g2"
                        : test.questions[0].allowRanking
                            ? "flex_col position_relative g2"
                            : "flex_row flex_col_tablet position_relative g2"
                }
            >
                <QuesLoader show={phase === "showing-loader"} />
                <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                    <div className="small-title">
                        {phrases?.["13106"]} {test.startNumber}
                    </div>
                    <div className="flex_col g2 base p4 roundness_1 border_tt82 full-height">
                        {location.state.test.displayType !== "3" &&
                            test.questions.map(
                                (val, ind) =>
                                    val.questionImage && (
                                        <img
                                            key={val.id}
                                            src={buildMediaUrl(
                                                val.questionImage
                                            )}
                                            alt="question-image"
                                            className="ques-img"
                                        />
                                    )
                            )}
                        {location.state.test.displayType !== "3" &&
                            test.questions.map(
                                (val, ind) =>
                                    val.media &&
                                    val.media.map((media, ind) => (
                                        <img
                                            key={media.id}
                                            src={buildMediaUrl(media.url)}
                                            alt="question-image"
                                            className="ques-img"
                                        />
                                    ))
                            )}
                        {location.state.test.displayType !== "3" &&
                            test.questions.map(
                                (val, ind) =>
                                    val.questionText && (
                                        <div
                                            className="questionText"
                                            key={val.id}
                                            dangerouslySetInnerHTML={{
                                                __html: val.questionText,
                                            }}
                                        />
                                    )
                            )}
                        {location.state.test.displayType === "3" && (
                            <img
                                src={buildMediaUrl(
                                    test.questions[0].questionImage
                                )}
                                alt="question-image"
                            />
                        )}
                    </div>
                </div>

                <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                    <div className="flex_row justify-content_between">
                        <div className="small-title">{phrases?.["15138"]}</div>
                        {!location.state.warmUp &&
                            location.state.test.timeByQuestion &&
                            location.state.test.bShowTimer && (
                                <div
                                    className={`tag-ds ${timerPerQuestion > 0 &&
                                            timerPerQuestion < totalSecLeft
                                            ? "status-tag_info"
                                            : "status-tag_error"
                                        }`}
                                >
                                    <span className="material-icons-outlined icon-order">
                                        timer
                                    </span>
                                    {min}:{sec}
                                </div>
                            )}
                    </div>
                    <div className="flex_col g2 align-items_centerr base p4 roundness_1 border_tt82 full-height">
                        {isDragandDrop ? (
                            <DragDrop
                                setDefaultOrderData={setDefaultOrderData}
                                defaultOrderData={defaultOrderData}
                                orderData={orderData}
                                setOrderData={setOrderData}
                                test={test}
                                maxSelection={test.questions[0].maxSelection}
                            />
                        ) : (
                            <>
                                {isSingleChoice ? (
                                    <fieldset
                                        aria-label="group-container"
                                        className="radio-group-container"
                                    >
                                        <div className="radio-group base 1">
                                            {test.questions[0].answers?.map(
                                                (val, ind) => (
                                                    <div
                                                        key={
                                                            test.startNumber +
                                                            ind
                                                        }
                                                        className="radio-container"
                                                    >
                                                        <input
                                                            id={`option-${ind}`}
                                                            type="radio"
                                                            value={val.position}
                                                            onChange={
                                                                changeSelectedAns
                                                            }
                                                            checked={
                                                                selectedAns ==
                                                                val.position
                                                            }
                                                        />
                                                        <label
                                                            dangerouslySetInnerHTML={{
                                                                __html: val.content,
                                                            }}
                                                            htmlFor={`option-${ind}`}
                                                        />
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </fieldset>
                                ) : isMultiChoice ? (
                                    <fieldset
                                        aria-label="group-container"
                                        className="checkbox-group-container"
                                    >
                                        <div className="checkbox-group base">
                                            {questionData?.answers?.map(
                                                (val, ind) => (
                                                    <div
                                                        key={
                                                            test.startNumber +
                                                            ind
                                                        }
                                                        className="checkbox-container"
                                                    >
                                                        <input
                                                            id={`option-${ind}`}
                                                            type="checkbox"
                                                            value={val.position}
                                                            checked={
                                                                val.selected
                                                            }
                                                            onClick={() =>
                                                                changeMultiSelectedAns(
                                                                    val,
                                                                    ind
                                                                )
                                                            }
                                                        />
                                                        <label
                                                            dangerouslySetInnerHTML={{
                                                                __html: val.content,
                                                            }}
                                                            htmlFor={`option-${ind}`}
                                                        />
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </fieldset>
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            </form>
            <hr />
            <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                <div>
                    {isWarmUp && (
                        <button
                            className="button-secondary  text_uppercase full-width_mobile"
                            disabled={loading}
                            onClick={() =>
                                navigate("/instructions", {
                                    state: { ...location.state },
                                })
                            }
                        >
                            {phrases?.["1000229"]}
                        </button>
                    )}
                    {!isWarmUp && !test.lastPage && (
                        <button
                            className="button-secondary text_uppercase full-width_mobile"
                            disabled={loading}
                            onClick={exitTest}
                        >
                            {phrases?.["1002190"]}
                        </button>
                    )}
                </div>
                <div className="flex align-items_center">
                    {isWarmUp ? (
                        <button
                            className="button-primary text_uppercase full-width_mobile ml4"
                            disabled={loading}
                            onClick={() => nextNavigate()}
                        >
                            {test.lastPage
                                ? location.state.warmUp
                                    ? rightAns
                                        ? phrases?.["1000252"]
                                        : phrases?.["10976"]
                                    : phrases?.["15140"]
                                : phrases?.["10976"]}
                        </button>
                    ) : (
                        <div className="flex align-items_center">
                            {location.state.test.previosNavegation &&
                                test.startNumber !== 1 && (
                                    <a
                                        role="link"
                                        className={`full-width_mobile ${loading ? "disabled" : ""
                                            }`}
                                        onClick={() => previousNavigate()}
                                    >
                                        <span className="material-icons pr2 ">
                                            arrow_back
                                        </span>
                                        {phrases?.["410"]}
                                    </a>
                                )}
                            <button
                                className="button-primary text_uppercase full-width_mobile ml4"
                                disabled={setNextDisable() || loading}
                                onClick={() => nextNavigate()}
                            >
                                {test.lastPage
                                    ? phrases?.["15140"]
                                    : phrases?.["10976"]}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TestTaker24;
